/**
 * 个人证书导入 2020-09-21
 */
import React from 'react';
import { connect } from 'dva';

import { component_tool, framework_tool } from '@/tool'
let { WizTypography, WizSpin, WizSelect, WizBrowserExport } = component_tool;
let { WizContainer } = framework_tool;
const { Paragraph } = WizTypography;
import { ExportExcel } from '@/components/index'
import { modelUtils } from '@/utils'
import { Dropdown, Select } from "antd";

class CertImport extends WizContainer {

  componentName = 'studentAbilityFileImport';

  constructor(props) {
    super(props);
    this.state = {
      type: null
    }
  }

  _handldImport(nextProps, nextState) {
    let o = nextProps['studentAbilityItemImport']
    if (o['success']) {
      let data = o['data'];
      let str = data.replace(/<br\/>/g, "\n")
      wizNotice.success({
        key: 'default',
        message: '成功',
        description: (
          <div>
            <p style={{ whiteSpace: "pre-line" }}>{str}</p>
          </div>
        ),
      })
      return true;
    } else {
      wizNotice.error({ key: 'personalCert-error', message: '出错了', description: <div dangerouslySetInnerHTML={{ __html: o.msg || "导入失败" }} /> })
      return false;
    }
  }

  //获取模版
  _handleFile(nextProps, nextState, key) {
    let o = nextProps['studentAbilityItemExportHead']
    let columnDefs = [];
    let columnDefsSociety = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      // {
      //   headerName: '角色名称',
      //   field: 'name',
      //   width: 25,
      //   cellStyle: {
      //     textAlign: 'center',
      //   },
      //   style: {
      //     alignment: { vertical: 'bottom', horizontal: 'center' },
      //   },
      // },
      // {
      //   headerName: '角色编码',
      //   field: 'code',
      //   width: 25,
      //   cellStyle: {
      //     textAlign: 'center',
      //   },
      //   style: {
      //     alignment: { vertical: 'bottom', horizontal: 'center' },
      //   },
      // },
      // {
      //   headerName: '角色描述',
      //   field: 'remark',
      //   width: 50,
      //   cellStyle: {
      //     textAlign: 'center',
      //   },
      //   style: {
      //     alignment: { vertical: 'bottom', horizontal: 'center' },
      //   },
      // }
    ]
    let columnDefsTrain = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '账号',
        field: 'account',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '证书名称',
        field: 'certName',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '获得途径',
        field: 'channel',
        width: 50,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '获得途径',
        field: 'channel',
        width: 50,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '证书获取时间',
        field: 'gainTime',
        width: 50,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      }
    ]
    if (o['success']) {
      let data = o['data']
      data.forEach(element => {
        let entity = {};
        entity.headerName = element.name;
        entity.width = 20;
        entity.cellStyle = { textAlign: 'center' };
        entity.style = { alignment: { vertical: 'bottom', horizontal: 'center' } };
        columnDefs = columnDefsTrain;
        columnDefs.push(entity);
      });
      WizBrowserExport({
        sheetName: '个人证书记录管理导入模版',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '个人证书记录管理导入.xlsx',
      })
      // wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _getTemp(type) {
    if (type == null) {
      wizNotice.error("请先选择证书类别");
      return;
    }
    let columnDefs = [];
    let columnDefsSociety = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '账号',
        field: 'account',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '证书名称',
        field: 'certName',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '证书编码',
        field: 'certCode',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '颁证单位',
        field: 'awardUnit',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '有效期-开始日期',
        field: 'startDate',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '有效期-结束日期',
        field: 'endDate',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '复审日期',
        field: 'reCheckDate',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '初领日期',
        field: 'firstDate',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
    ]
    let columnDefsTrain = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '账号',
        field: 'account',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '证书名称',
        field: 'certName',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '获得途径',
        field: 'channel',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '获得时间',
        field: 'gainTime',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '证书状态',
        field: 'state',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      }
    ]
    let name = '';
    let rows = [];
    if (type == 1) {
      columnDefs = columnDefsTrain;
      name = '个人证书记录培训证书导入模版';
      rows.push({ 'account': 'zhangsan', 'certName': '别克销售顾问认证', 'channel': '完成销售顾问3星远程认证并通过认证', 'gainTime': '2020-10-10', 'state': '有效' });
    } else {
      columnDefs = columnDefsSociety;
      name = '个人证书记录社会证书导入模版';
      rows.push({
        'account': 'zhangsan', 'certName': '电工证', 'certCode': 'DZJ10202254', 'awardUnit': '国家能源局',
        'startDate': '2020-08-10', 'endDate': '2022-08-10', 'reCheckDate': '2020-10-09', 'firstDate': '2005-10-12'
      });
    }
    WizBrowserExport({
      sheetName: name,
      columns: columnDefs.filter((_, index) => index),
      rows: rows,
      filename: name + '.xlsx',
    })
    return true;
  }



  propsAndStateOnChange = {
    studentAbilityItemImport: this._handldImport.bind(this),
    studentAbilityItemExportHead: this._handleFile.bind(this)
  }


  onGenderChange = value => {
    this.state.type = value;
  }


  _render() {
    let infoProps = {
      title: '导入说明',
      text: [
        <Paragraph>1、从模版链接中下载模版文件</Paragraph>,
        <Paragraph>2、按照要求格式填写信息</Paragraph>,
        <Paragraph>3、当完成Excel文件的填写后，点击“上传文件”按钮上传此文件</Paragraph>,
      ]
    }
    let operateProps = {
      title: '个人证书记录导入',
      template: {
        label: '模版下载',
        fileName: '模版.xlsx',
        onClick: () => { this._getTemp(this.state.type) },
      }
    }
    let submit = (file, fileData) => {
      if (!this.state.type) {
        wizNotice.error("请先选择证书类别");
        return;
      }

      let apiPath = 'certRecord/importFile';
      this.doAction({
        path: apiPath,
        payload: {
          key: "import",
          apiParams: {
            fileData,
            "type": this.state.type
          }
        }
      });
    }

    let other = [
      {
        /**
         * item的参数
         */
        item: { label: '证书类别', required: true },
        /**
         * 渲染内容的方法
         */
        comp: (callback) => {
          return (
            <WizSelect
              className='wizTableForm-default-select'
              placeholder="请选择证书类别"
              onChange={this.onGenderChange}
              allowClear
            >
              <WizSelect.Option value="1">培训证书</WizSelect.Option>
              <WizSelect.Option value="2">社会证书</WizSelect.Option>
            </WizSelect>
          )
        }
      }
    ]


    let { certRecordLoading } = this.props;
    return (
      <ExportExcel
        infoProps={infoProps}
        operateProps={operateProps}
        other={other}
        submit={submit}
        loading={certRecordLoading}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { studentAbilityItem, certRecord } = state;
  const studentAbilityItemImport = modelUtils.getModelEntity(certRecord, 'import');
  const studentAbilityItemExportHead = modelUtils.getModelEntity(studentAbilityItem, 'studentAbilityItemExportHead');

  //获取loading的方式
  const load = modelUtils.getLoadingState(state, ['certRecord', 'studentAbilityItem'])
  return {
    studentAbilityItemImport: studentAbilityItemImport,
    studentAbilityItemExportHead: studentAbilityItemExportHead,
    ...load
  }
};

export default connect(mapStateToProps)(CertImport);
